module.exports = __webpack_public_path__ + "pnskfsquadron/img/book-bg2.png?3b5f7760";